import React, { useState } from "react";
import "./ForgotsPassword.css";
import Header from "../../components/Header/Header";
import BottomNav from "../../components/BottomNav/BottomNav";

export default function ForgotPassword({ onSubmit }) {
  const [formData, setFormData] = useState({
    accountName: "",
    bankLastFive: "",
  });

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit?.(formData);
  };

  return (
    <>
        <Header />
    <div className="fp-page">
      <div className="fp-wrap">
        <h1 className="fp-title">Forgot Password</h1>

        <form className="fp-form" onSubmit={handleSubmit}>
          <div className="fp-field">
            <label className="fp-label">
              Account Name<span className="fp-required">*</span>
            </label>

            <input
              type="text"
              className="fp-input"
              placeholder="Account Name"
              value={formData.accountName}
              onChange={(e) => handleChange("accountName", e.target.value)}
            />
          </div>

          <div className="fp-field">
            <label className="fp-label">
              Bank Account Number<span className="fp-required">*</span>
            </label>

            <input
              type="text"
              className="fp-input"
              placeholder="Last 5 Digits Of The Bank Account Number"
              value={formData.bankLastFive}
              onChange={(e) => handleChange("bankLastFive", e.target.value)}
            />
          </div>

          <button type="submit" className="fp-submit-btn">
            Submit
          </button>
        </form>
      </div>
    </div>
    <BottomNav />
    </>
  );
}